<template>
    <div v-if="viewedOriginCertificateProducts.length > 0">
        <div class="cards" v-for="(item,index) in viewedOriginCertificateProducts" :key="index">
            <van-row type="flex" justify="space-between" style="align-items: center">
                <span class="title">商品 - {{ index + 1 }}</span>
            </van-row>

            <van-row>
                <span class="label">商品税则号</span>
                <span class="cont">{{ item.hsCode }}</span>
            </van-row>

            <van-row>
                <span class="label">原产国</span>
                <span class="cont">{{ item.countryId }}</span>
            </van-row>

            <van-row>
                <span class="label">FOB价格</span>
                <span class="cont">{{ item.fobValue }}</span>
            </van-row>

        </div>
    </div>
</template>

<script>

    export default {
        name: "exportProductCardView",
        props: {
            viewedOriginCertificateProducts: Array,
        },
        data() {
            return {}
        },
        created() {
        },
        methods: {}
    }
</script>



